import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={50.087} height={58.603} {...props}>
    <path
      data-name="Path 7606"
      d="M1531.4 667.936h22.107V702.1h-18.473a3.656 3.656 0 0 1-3.633-3.658zm24.465 34.162h18.474a3.655 3.655 0 0 0 3.632-3.658v-30.5h-22.106zm23.852-39.565v3.043h-50.087v-3.043a4.632 4.632 0 0 1 4.625-4.624h7.031a15.061 15.061 0 0 1 29.089-5.851 8.443 8.443 0 0 1-2.358 5.851h7.1a4.611 4.611 0 0 1 4.6 4.624zm-23.687-11.065v.095a5.308 5.308 0 0 1 0 .991v.095a5.8 5.8 0 1 0 0-1.18zm-14.344.59a5.806 5.806 0 0 0 11.607.259 1.469 1.469 0 0 1 0-.519 5.806 5.806 0 0 0-11.607.259z"
      transform="translate(-1529.63 -643.495)"
      style={{
        fill: '#fff'
      }}
    />
  </svg>
);

export default SvgComponent;
